<template>
  <li :class="b()">
    <c-magnifier-picture v-bind="image"
                         :sizes="sizes"
                         :disabled="disableMagnification"
                         :teleport-to="teleportMagnificationTo"
                         :is-lcp-candidate="isLcpCandidate"
    />
  </li>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue';
  import cMagnifierPicture from '@/components/c-magnifier-picture.vue';
  import { ImageSrcset } from '@/types/image';
  import { ImageSizes } from '@/types/sizes';

  // interface Setup {}
  // interface Data {}

  /**
   * Renders a product slide with image zoom.
   */
  export default defineComponent({
    name: 'c-slider-item-2',

    components: {
      cMagnifierPicture,
    },

    props: {
      /**
       * Expects an ImageSrcset.
       */
      image: {
        type: Object as PropType<ImageSrcset>,
        required: true,
      },

      /**
       * Allows to disable the image magnification functionality.
       */
      disableMagnification: {
        type: Boolean,
        default: false,
      },

      /**
       * Allows to define an alternative <Teleport> name.
       */
      teleportMagnificationTo: {
        type: String,
        default: undefined,
      },

      /**
       * Allows to set an alternative sizes definition.
       */
      sizes: {
        type: Object as PropType<ImageSizes>,
        default: () => ({
          xxs: 480,
          xs: 728,
          sm: 952,
          fallback: 307,
        }),
      },

      /**
       * Allows defining if the current item is a potential LCP candidate.
       */
      isLcpCandidate: {
        type: Boolean,
        default: false,
      },
    },
    // emits: {},

    // setup(): Setup {},
    // data(): Data {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use 'sass:math';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';

  .c-slider-item-2 {
    position: relative;
    flex: 0 0 100%;
  }
</style>
